import { render, staticRenderFns } from "./ReadDocument.vue?vue&type=template&id=1acdd566&"
import script from "./ReadDocument.js?vue&type=script&lang=js&"
export * from "./ReadDocument.js?vue&type=script&lang=js&"
import style0 from "./ReadDocument.vue?vue&type=style&index=0&id=1acdd566&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports